var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7969 5L20.7969 9L18.7969 5M16.7969 5H14.7969V9H16.7969M14.7969 7H16.2969",
    stroke: "#9C4900",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 9V19C6.79688 19.5304 7.00759 20.0391 7.38266 20.4142C7.75773 20.7893 8.26644 21 8.79688 21H17.7969C18.3273 21 18.836 20.7893 19.2111 20.4142C19.5862 20.0391 19.7969 19.5304 19.7969 19V14M4.79688 5V3M8.79688 5V3M9.79688 5.6V7C9.79688 7.53043 9.58616 8.03914 9.21109 8.41421C8.83602 8.78929 8.32731 9 7.79688 9H5.79688C5.26644 9 4.75773 8.78929 4.38266 8.41421C4.00759 8.03914 3.79688 7.53043 3.79688 7V5.6C3.79687 5.44087 3.86009 5.28826 3.97261 5.17574C4.08513 5.06321 4.23775 5 4.39687 5H9.19687C9.356 5 9.50862 5.06321 9.62114 5.17574C9.73366 5.28826 9.79688 5.44087 9.79688 5.6Z",
    stroke: "#9C4900",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvLogo);
export default __webpack_public_path__ + "static/media/EV-logo.9c16aa4c0f2b8166839d5d6836da2ee3.svg";
export { ForwardRef as ReactComponent };